import { useAtom, atom } from 'jotai';

export const expandedInboundLoadsAtom = atom<string[]>([]);

export const useExpandedInboundLoads = () => useAtom(expandedInboundLoadsAtom);
